import React, {useContext, useEffect, useState} from 'react';
import axios from 'axios';
import classes from './FoodBeveragesDetail.module.scss';
import ReactGa from "react-ga";
import {Helmet} from "react-helmet";
import scrollToComponent from "react-scroll-to-component";
import {HomeBreadcrumb} from "../../../components/UI/HomeButton";
import JIcon from "../../../components/UI/Icon/JIcon";
import DateIcon from "../../../components/UI/DateComponent/DateIcon";
import AuthorInfo from "../../../components/UI/AuthorInfo/AuthorInfo";
import {LoadingSimple} from "../../../components/UI/LoadingBar";
import {FormattedMessage} from "react-intl";
import {Context} from "../../../context/Wrapper";

const FoodBeveragesDetailHooks = (props) => {

    const context = useContext(Context)
    const [state, setState] = useState({
        isLoading: false
        , my_list: []
        , selected_data: []
    });

    useEffect(() => {
        //=================================================
        // console.log('useEffect 1');
        //=================================================

        //add by hendra on 14 oct 2020
        ReactGa.pageview(window.location.origin.toString() + props.location.pathname);
        const loadDocumentTitle = () => {
            document.title =
                localStorage.getItem('food_beverages:selected_detail') !== null ?
                    localStorage.getItem('food_beverages:selected_detail') &&
                    `${localStorage.getItem('food_beverages:selected_detail')}${(" | Food & Beverages Trends | Japfa Food | Indonesia | Food Supplier")}`
                    :
                    "Food & Beverages Trends Detail | Food & Beverages Trends | Japfa Food | Indonesia | Food Supplier"
        }
        window.scrollTo(0, 0);

        const ourRequest = axios.CancelToken.source()
        const fetchData = async () => {
            setState({...state, isLoading: true})
            const header = {headers: {'language': context.locale}};
            const getData_1 = await axios.get('food_beverage/' + props.match.params.id, header);
            setState({
                selected_data: getData_1.data,
                done: false
            });
        }
        try {
            fetchData();
            loadDocumentTitle();
        } catch (e) {
            if (e.response.status === 404) {
                props.history.replace("/page-not-found")
            }
        }

        return () => {
            ourRequest.cancel();
        }
        //eslint-disable-next-line
    }, [props.location.pathname, props.history, props.match.params.id, context.locale]);

    let tempMetaDesc = '';
    let metaDesc = '';
    if (state.selected_data && state.selected_data.length > 0) {
        tempMetaDesc = state.selected_data.content.replace(/(<([^>]+)>)/ig, "");
        metaDesc = tempMetaDesc.length > 150 ? tempMetaDesc.substr(0, 150).trim() : tempMetaDesc.trim();
    }

    return (
        <>
            <div className={["violet", classes.FoodBeveragesDetail_container].join(' ')} ref={(section) => {
                scrollToComponent.Violet = section;
            }}>

                <Helmet>
                    <meta name="description" content={metaDesc}/>
                    <meta name="keywords" content={"food service, frozen food, supplier frozen food, Best Chicken, Tokusen, Omayo, food catering, food service delivery, Japfa Indonesia, meat shop, Chicken shop, food solutions, JBFS, Food Supplier"}/>
                    <meta name="author" content=""/>
                    <meta property="og:title"
                          content={state.selected_data.length > 0 &&
                          `${state.selected_data.title}${(" | Food & Beverages Trends | Japfa Food | Indonesia | Food Supplier")}`
                          }/>
                    <meta property="og:description" content={metaDesc}/>
                    <title>{
                        localStorage.getItem('food_beverages:selected_detail') &&
                        `${localStorage.getItem('food_beverages:selected_detail')}${(" | Food & Beverages Trends | Japfa Food | Indonesia | Food Supplier")}`
                    }</title>

                    <link rel="canonical" href={window.location.origin.toString() + props.location.pathname}/>
                </Helmet>

                {/*Bread crumbs region*/}
                <section className={[classes.FoodBeveragesDetail_sectionBread].join(' ')}>
                    <div className={["jbfs-wrapper", classes.FoodBeveragesDetail_wrapperBread].join(' ')}>
                        <div className={["jbfs-breadcrumb-row",].join(' ')}>
                            <HomeBreadcrumb/>
                            <span>/</span>
                            <div><FormattedMessage id={"fnbpage.title"} defaultMessage={"Food & Beverages Trends"}/></div>
                        </div>
                    </div>
                </section>
                {/*Bread crumbs region*/}

                <section className={classes.FoodBeveragesDetail_sectionHeader}>
                    <div className={["jbfs-wrapper", classes.FoodBeveragesDetail_wrapperHeader].join(' ')}>
                        <div>
                            <h1><FormattedMessage id={"fnbpage.title"} defaultMessage={"Food & Beverages Trends"}/></h1>
                        </div>
                    </div>
                </section>

                <section className={classes.FoodBeveragesDetail_sectionContent}>
                    <div className={["jbfs-wrapper", classes.FoodBeveragesDetail_wrapperContent].join(' ')}>
                        <div className={classes.WrapperContent_card}>
                            <div className={classes.ImageHero_row}>
                                <div style={{backgroundImage: `url(${(state.selected_data ? state.selected_data.image : <LoadingSimple/>)})`}}/>
                            </div>
                            <div className={classes.Content_row}>
                                {state.selected_data && state.selected_data.length < 1 ? (<LoadingSimple/>) : (
                                    <>
                                        <DateIcon classMy={classes.Date_component} created_on={state.selected_data.created_on}/>
                                        <div className={classes.Content_wrapper}>
                                            <h2 dangerouslySetInnerHTML={{__html: state.selected_data.title}}/>
                                            <div className={classes.Auth_Info}>
                                                <AuthorInfo created_on={state.selected_data.created_on} created_by={state.selected_data.created_by}/>
                                            </div>
                                            <div className={classes.Description} dangerouslySetInnerHTML={{__html: state.selected_data.content}}/>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div className={["jbfs-goto-top-button",].join(' ')} hidden>
                <JIcon icontype={"link_to_top"}
                       onClick={() => scrollToComponent(scrollToComponent.Violet, {offset: -99, align: 'top', duration: 1500})}/>
            </div>
        </>
    )
}

export default FoodBeveragesDetailHooks